import {SITE_URL} from '@util/URLUtils';
import {Button, Message} from '@ultradent/components';
import Icon from '@components/common/Icon';
import ProgressBar from '@components/registration/ProgressBar';
import {Navigate, useLocation, useOutletContext} from 'react-router-dom';

const AccountVerifiedNPI = ( props ) => {
    const location = useLocation();
    const context = useOutletContext();

    if ( !context.authorization( useLocation() ).hasEmailAddress() ) {
        return <Navigate to="/"/>
    }

    return (
        <div>

        <ProgressBar step={'3'} completed={[1, 1, 1]} labels={['create login', 'verify account', 'verified']}
                     isSubmitted={location.state.isSubmitted}/>

        <h1 className="font-light text-center text-2xl md:text-4xl regSubHeading mx-auto">All Done!</h1>
        <div className="leading-tight universalForm-container text-near-black my-4 md:my-12 mx-auto">
            {context.state.signUpError &&
                <Message notice
                         className="flex font-normal items-center -ml-4 -mr-4 md:-ml-8 md:-mr-8 px-4 md:px-8 py-4 text-white w-auto mb-4">
                    <Icon.ui wrapperClassName="mr-2" className="text-white text-xl"
                             name="report-problem-triangle"/>
                    <span
                        className="message-bar-msg">There was an error submitting this request, please try again.</span>
                </Message>
            }
            <Icon.ui
                className="items-center text-success text-5xl mb-4"
                wrapperClassName="justify-center"
                center
                name="checkmark-circle"
            />
            <p className="text-center font-normal mx-auto">Your account has been activated. You now have the
                ability to order products online, view your order history, request a return or equipment repair and
                register for seminars.</p>
            {location.state.registrationResult?.loggedIn === false && <p className="text-center mt-4">Your login was created. Please sign in to continue.</p>}
            {location.state.registrationResult?.notificationSent === false && <p className="text-center mt-4">Your login was created, but the welcome email could not be sent.</p>}
            <p className="mt-8 text-center font-normal mx-auto">Also, be sure to <strong>sign up for the Ultradent
                Newsletter</strong> to receive extra promotions and more!</p>
            <p className="my-4 text-center text-lg">{location.state.emailAddress}</p>
            <Button onClick={!context.state.signUpSuccess ? () => context.signUp( location.state.emailAddress ) : null}
                    className={`full ${context.state.signUpSuccess ? 'success' : 'primary'}`}
                    loading={context.state.signUpLoading}
                    disabled={context.state.signUpSubmitting}>
                {context.state.signUpSuccess ? 'Thank You!' : 'Yes, sign me up!'}
            </Button>

            <div className="text-center">
                <a href={SITE_URL} className="block full link-2 mt-12">
                    Start Shopping
                </a>
            </div>
        </div>
    </div>
    );
}

export default AccountVerifiedNPI;
